<i18n>
{
  "en": {
    "managedProducts": "Revenue managed products",
    "referencePrices": "Products with reference price",
    "minMaxPrices": "Products with min and max prices",
    "unitCosts": "Products with unit cost",
    "processingSpeed": "All products with processing speed",
    "stocks": "At least half the products with fulfilled stock",
    "back": "Back"
  },
  "es": {
    "managedProducts": "Productos con gestión de ingresos activa",
    "referencePrices": "Productos con precio de referencia",
    "minMaxPrices": "Productos con precios máximo y mínimo",
    "unitCosts": "Productos con coste unitario",
    "processingSpeed": "Todos los productos con velocidad de elaboración",
    "stocks": "Al menos la mitad de los productos con existencias",
    "back": "Atrás"
  }
}
</i18n>
<template>
  <v-container v-if="profileCompletion">
    <div class="text-center font-weight-bold mt-7 mb-5 text-h5"> {{ selectedPointOfSale.name }}</div>
    <completion-bar :value="profileCompletion.managedProducts"
                    :max="profileCompletion.managedProducts"
                    :percentage="profileCompletion.managedProducts100"
                    :name="$t('managedProducts')"
                    :weight="profileCompletion.managedProductsWeight"/>
    <completion-bar :value="profileCompletion.referencePrices"
                    :max="profileCompletion.managedProducts"
                    :percentage="profileCompletion.referencePrices100"
                    :name="$t('referencePrices')"
                    :weight="profileCompletion.referencePricesWeight"
                    class="mt-6"/>
    <completion-bar :value="profileCompletion.minMaxPrices"
                    :max="profileCompletion.managedProducts"
                    :percentage="profileCompletion.minMaxPrices100"
                    :name="$t('minMaxPrices')"
                    :weight="profileCompletion.minMaxPricesWeight"
                    class="mt-6"/>
    <completion-bar :value="profileCompletion.unitCosts"
                    :max="profileCompletion.managedProducts"
                    :percentage="profileCompletion.unitCosts100"
                    :name="$t('unitCosts')"
                    :weight="profileCompletion.unitCostsWeight"
                    class="mt-6"/>
    <div class="d-flex mx-6 mt-5">
      <completion-star
                  :value="profileCompletion.processingSpeedsCalculated"
                  :name="$t('processingSpeed')"
                  :weight="profileCompletion.processingSpeedsWeight"
                  class="completion-star"/>
      <completion-star
                  :value="profileCompletion.stocksCalculated"
                  :name="$t('stocks')"
                  :weight="profileCompletion.stocksWeight"
                  class="completion-star"/>
    </div>
    <dynameat-confirmation-buttons :confirm-visible="false" :cancel-text="$t('back')" @cancel="onBack"
      class="ml-4"/>
  </v-container>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import DynameatConfirmationButtons from '@dynameat/components/DynameatConfirmationButtons';
import { COMPLETION_THRESHOLDS } from '@dynameat/models/profileCompletion';
import CompletionStar from './components/CompletionStar.vue';
import CompletionBar from './components/CompletionBar.vue';

@Component
@Components({ CompletionBar, CompletionStar, DynameatConfirmationButtons })
@MapActions(['setSelectedPointOfSaleGuid'])
@MapGetters(['selectedPointOfSale', 'profileCompletion'])
export default class CompletionDetail extends Vue {
  COMPLETION_THRESHOLDS = COMPLETION_THRESHOLDS

  onBack() {
    this.setSelectedPointOfSaleGuid(null);
    this.$router.push({ name: 'completion' });
  }
}
</script>

<style scoped>
.completion-star{
  width: 50%;
}
</style>
